import { render, staticRenderFns } from "./updateContent.vue?vue&type=template&id=5ead7365"
import script from "./updateContent.vue?vue&type=script&lang=js"
export * from "./updateContent.vue?vue&type=script&lang=js"
import style0 from "./updateContent.vue?vue&type=style&index=0&id=5ead7365&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports